import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../../common.css";
import "../../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrantCommonTabs from '../../../../../../components/common/SelectingWarrantCommonTabs';
import SelectingWarrentImg from '../../../../../../components/common/SelectingWarrentImg';


const TimeFrames = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='share_capital Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }} />
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>How to select a Warrant?</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Timeframe</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>Gearing Level</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        <title>Timeframe</title>
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .contentbox table{\n                margin: 0 auto;\n            }\n            .contentbox table thead th{\n                background-color: #FFD400;\n            }\n            .contentbox table tbody td,\n            .contentbox table thead th{\n                height:2em;\n                padding:0 1em;\n                color:#000000;\n                text-align: center;\n            }\n            .contentbox table tbody td.bgc0{\n                background-color: #FFF4D2;\n            }\n            .contentbox table thead th.bgc1 {\n                background-color: #9E9FA1;\n            }\n            .contentbox table tbody td.bgc2{\n                background-color: #C0C1C2;\n            }\n            .contentbox table tbody tr.active td{\n                background-color: #FD8C8F;\n            }\n            .ms .contentbox table.ctable\n            .xs .contentbox table.ctable,\n            .xxs .contentbox table.ctable{\n               font-size:11px;\n            }\n            .ms .contentbox table  td,\n            .ms .contentbox table  th,\n            .xs .contentbox table  td,\n            .xs .contentbox table  th,\n            .xxs .contentbox table td,\n            .xxs .contentbox table th{\n                padding:0.5em;\n            }\n            .imgholder .imgmask{\n                position:relative;\n                margin:auto;\n            }\n            .imgholder .area{\n                position:absolute;\n                display:block;\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>When choosing a warrant, we suggest that investors consider the following 4 steps: </p>

                                            <div className="imgholder hidden-xs">
                                                <SelectingWarrantCommonTabs Location={location} Hist={history} />
                                            </div>
                                            <p>
                                                Think of how long you expect to be holding on to your warrant position. You also need to consider your risk tolerance. For example, if you are someone with a low risk tolerance and intend to hold on to your positions for a month, you might select a warrant with expiries of 3 months or more to give yourself some buffer. If you are someone with a high risk tolerance, you might select a shorter dated warrant to benefit from the increased leverage.
                                            </p>
                                            <div className="imgholder">
                                                <img src='/img/education/timeframe.png' style={{ maxWidth: '180px' }} />
                                            </div>

                                            <p>
                                                A word of caution however on shorter dated warrants, a warrant that is approaching expiry (say with only 1 month or less to expiry) will decay at a high and increasing rate (for more information on time decay <Link to="/edu/understanding-warrant-structure/time-decay" target="_blank">click here</Link>). So, while you can often earn a higher return on these warrants if your view is right, you are also taking on a higher risk as the warrant price will quickly decay in value. You must be very nimble when trading short dated warrants.
                                            </p>
                                            <h2>
                                                What is your timeframe?
                                            </h2>
                                            <p>
                                                Assume the date is 23 January and all warrants listed below expire within the same year. Warrant A, which expires in about a month on 28 February, may be too short dated for investors looking to hold the warrant for a longer period of time.
                                            </p>
                                            <div className="imgholder">
                                                <img style={{ maxWidth: '889px' }} src='/img/education/table1.png' />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/tablemob1.png") }}
                                                    >View table
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/select-warrant/selecting-warrant/gearing-level">
                                                <span className="prevname "> Gearing Level</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/select-warrant/selecting-warrant/gearing-level">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/select-warrant/selecting-warrant">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/select-warrant/selecting-warrant">
                                                <span className="prevname ">Selecting a warrant</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl} />
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default TimeFrames;